module.exports = __webpack_public_path__ + "assets/faw-logo-navbar.b27db7a4734bc135b391a03ab2d33393.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/faw-logo-navbar.png
// module id = 654
// module chunks = 1